// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_COMMENT = "pridanie odpovede";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT = "Naozaj chce\u0161 zmaza\u0165 koment\u00e1r?";
